import DashboardShare from './DashboardShare';

export default DashboardShare;
